<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <h1 class="mb-5">Hipoteka / Įkeitimas</h1>
    <v-card class="pa-5">
      <template>
        <v-item-group class="mb-4">
          <v-row align="stretch">
            <v-col
              v-for="(tipas, index) in filterTipasList"
              :key="index"
              cols="12"
              md="2"
            >
              <v-item v-slot="{ active, toggle }">
                <v-card
                  class="mx-auto"
                  @click="checkTipas(toggle, active, tipas)"
                  height="100%"
                  :elevation="active ? '5' : '0'"
                >
                  <el-tipas-icon
                    :icon="tipas.icon"
                    :type="tipas.iconType"
                    :active="active"
                  >
                  </el-tipas-icon>
                  <v-card-text>
                    <div :color="active ? 'primary' : 'disabled'">
                      {{ tipas.title }}
                    </div>
                  </v-card-text>
                </v-card>
              </v-item>
            </v-col>
          </v-row>
        </v-item-group>
      </template>
      <template v-if="isTipas">
        <v-item-group class="mb-4">
          <v-row align="stretch">
            <v-col
              v-for="(veiksmas, index) in filterVeiksmasList"
              :key="index"
              cols="12"
              md="2"
            >
              <v-item v-slot="{ active, toggle }">
                <v-card
                  class="mx-auto"
                  @click="checkVeiksmas(toggle, active, veiksmas)"
                  height="100%"
                  :elevation="active && isVeiksmas ? '5' : '0'"
                >
                  <el-tipas-icon
                    :icon="veiksmas.icon"
                    :active="active && isVeiksmas"
                    type="hipoteka"
                  >
                  </el-tipas-icon>
                  <v-card-text>
                    <div :color="active ? 'primary' : 'disabled'">
                      {{ veiksmas.title }}
                    </div>
                  </v-card-text>
                </v-card>
              </v-item>
            </v-col>
          </v-row>
        </v-item-group>
      </template>
      <template v-if="isVykdomasis">
        <v-item-group class="mb-4">
          <v-row align="stretch">
            <v-col
              v-for="(vykdomasis, index) in filterVykdomasisList"
              :key="index"
              cols="12"
              md="2"
            >
              <v-item v-slot="{ active, toggle }">
                <v-card
                  class="mx-auto"
                  @click="checkVykdomasis(toggle, active, vykdomasis)"
                  height="100%"
                  :elevation="active && isVykdomasis ? '5' : '0'"
                >
                  <el-tipas-icon
                    :icon="vykdomasis.icon"
                    :active="active && isVykdomasis"
                  >
                  </el-tipas-icon>
                  <v-card-text>
                    <div :color="active ? 'primary' : 'disabled'">
                      {{ vykdomasis.title }}
                    </div>
                  </v-card-text>
                </v-card>
              </v-item>
            </v-col>
          </v-row>
        </v-item-group>
      </template>

      <template v-if="isVeiksmasContinued || isVeiksmasNew">
        <div class="dataContainer">
          <v-row align="baseline" class="mb-4">
            <template v-if="objektasNerastas">
              <v-col cols="6" md="12">
                <v-alert dense outlined type="error">
                  {{ objektasNerastasMsg }}
                </v-alert>
              </v-col>
            </template>

            <template v-if="isVeiksmasContinued">
              <v-col cols="12" md="8">
                <el-text-field
                  label="Identifikavimo kodas (IDK)"
                  tooltip="Hipoteka. Kūrimas. Identifikavimo kodas (IDK)"
                  v-model="searchKodas"
                  idk
                />
              </v-col>
            </template>

            <v-col cols="12" md="12" v-if="isKodas && tipasKitas">
              <v-alert dense outlined type="warning">
                Rastas dokumentas:
                <h4 :class="tipasKitas">{{ hipotekaTitle }}</h4>
              </v-alert>
            </v-col>

            <v-col cols="12" md="8">
              <template v-if="hipotekaRole">
                <el-button
                  v-if="isVeiksmasContinued"
                  primary
                  @click.native="checkKodas()"
                  :loading="loadingSearch"
                  :disabled="!canSubmit"
                  >{{ hipotekaButtonText }}</el-button
                >
                <el-button
                  v-if="isVeiksmasNew"
                  primary
                  @click.native="sukurtiHipoteka()"
                  :loading="loadingSearch"
                  :disabled="!canSubmit"
                  >{{ hipotekaButtonText }}</el-button
                >
              </template>
              <template v-if="!hipotekaRole">
                <el-role-negalima class="mt-2" />
              </template>
            </v-col>
          </v-row>
        </div>
      </template>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '../../mixins/userRole'
import HipotekaMap from './hipotekaMap'

export default {
  name: 'Hipoteka',
  mixins: [userRole],
  data() {
    return {
      pageloading: true,
      vykdomasis: null,
      veiksmas: null,
      tipas: null,
      objektas: null,
      searchKodas: null,
      tipasKitas: null,
      objektasNerastas: false,
      loadingSearch: false,
      objektasNerastasMsg: null,
      tipasList: [
        {
          key: 'sutartinis-hipoteka',
          type: 'sutartinis',
          title: 'Sutartinė hipoteka',
          icon: 'mdi-bank-check',
          role: [
            'DT_notaras',
            'DT_notaro_padejejas',
            'DT_notaro_atstovas',
            'DT_teismas',
            'DT_antstolis',
            'DT_JA',
            'RG_STSR_registrat',
            'RG_NTR_registrat',
            'RG_NTR_vadovas',
          ],
        },
        {
          key: 'sutartinis-ikeitimas',
          type: 'sutartinis',
          title: 'Sutartinis įkeitimas',
          icon: 'mdi-briefcase-edit-outline',
          role: [
            'DT_notaras',
            'DT_notaro_padejejas',
            'DT_notaro_atstovas',
            'DT_teismas',
            'DT_antstolis',
            'DT_JA',
            'RG_STSR_registrat',
            'RG_NTR_registrat',
            'RG_NTR_vadovas',
          ],
        },
        {
          key: 'priverstinis-hipoteka',
          type: 'priverstinis',
          title: 'Priverstinė hipoteka',
          icon: 'mdi-bank-minus',
          role: [
            'DT_notaras',
            'DT_notaro_padejejas',
            'DT_notaro_atstovas',
            'DT_teismas',
            'DT_antstolis',
            'DT_kita_institucija',
            'DT_JA',
            'RG_STSR_registrat',
            'RG_NTR_registrat',
            'RG_NTR_vadovas',
          ],
        },
        {
          key: 'priverstinis-ikeitimas',
          type: 'priverstinis',
          title: 'Priverstinis įkeitimas',
          icon: 'mdi-briefcase-minus-outline',
          role: [
            'DT_notaras',
            'DT_notaro_padejejas',
            'DT_notaro_atstovas',
            'DT_teismas',
            'DT_antstolis',
            'DT_kita_institucija',
            'DT_JA',
            'RG_STSR_registrat',
            'RG_NTR_registrat',
            'RG_NTR_vadovas',
          ],
        },
        {
          key: 'perleidimas',
          type: 'perleidimas',
          title: 'Reikalavimo teisės perleidimas',
          icon: 'mdi-transfer',
          iconType: 'perleidimas',
          role: ['DT_JA'],
        },
      ],
      veiksmasList: [
        {
          key: 'sandoris',
          type: 'sutartinis new',
          title: 'Sandorio sudarymas',
          icon: 'mdi-clipboard-edit-outline',
          role: [
            'DT_notaras',
            'DT_notaro_padejejas',
            'DT_notaro_atstovas',
            'RG_STSR_registrat',
            'RG_NTR_registrat',
            'RG_NTR_vadovas',
          ],
        },
        {
          key: 'nustatymas',
          type: 'priverstinis new',
          title: 'Nustatymas',
          icon: 'mdi-clipboard-check-outline',
          role: [
            'DT_notaras',
            'DT_notaro_padejejas',
            'DT_notaro_atstovas',
            'DT_teismas',
            'DT_kita_institucija',
            'RG_STSR_registrat',
            'RG_NTR_registrat',
            'RG_NTR_vadovas',
          ],
        },
        {
          key: 'pakeitimas',
          type: 'sutartinis continued',
          title: 'Pakeitimas',
          icon: 'mdi-clipboard-flow-outline',
          role: [
            'DT_notaras',
            'DT_notaro_padejejas',
            'DT_notaro_atstovas',
            'DT_teismas',
            'DT_antstolis',
            'RG_STSR_registrat',
            'RG_NTR_registrat',
            'RG_NTR_vadovas',
          ],
        },
        {
          key: 'pakeitimas',
          type: 'priverstinis continued',
          title: 'Pakeitimas',
          icon: 'mdi-clipboard-flow-outline',
          role: [
            'DT_notaras',
            'DT_notaro_padejejas',
            'DT_notaro_atstovas',
            'DT_teismas',
            'DT_antstolis',
            'DT_kita_institucija',
            'RG_STSR_registrat',
            'RG_NTR_registrat',
            'RG_NTR_vadovas',
          ],
        },
        {
          key: 'pakeitimas-adresas',
          type: 'sutartinis priverstinis continued',
          title: 'Pakeitimas dėl adresų keitimo',
          icon: 'mdi-clipboard-minus-outline',
          role: ['DT_JA'],
        },
        {
          key: 'pabaiga',
          type: 'sutartinis continued',
          title: 'Pabaiga',
          icon: 'mdi-clipboard-remove-outline',
          role: [
            'DT_notaras',
            'DT_notaro_padejejas',
            'DT_notaro_atstovas',
            'DT_teismas',
            'DT_antstolis',
            'DT_JA',
            'RG_STSR_registrat',
            'RG_NTR_registrat',
            'RG_NTR_vadovas',
          ],
        },
        {
          key: 'pabaiga',
          type: 'priverstinis continued',
          title: 'Pabaiga',
          icon: 'mdi-clipboard-remove-outline',
          role: [
            'DT_notaras',
            'DT_notaro_padejejas',
            'DT_notaro_atstovas',
            'DT_teismas',
            'DT_antstolis',
            'DT_kita_institucija',
            'DT_JA',
            'RG_STSR_registrat',
            'RG_NTR_registrat',
            'RG_NTR_vadovas',
          ],
        },
        // {
        //   key: 'isigaliojimas',
        //   type: 'sutartinis continued',
        //   title: 'Sąlygos įsigaliojimas',
        //   icon: 'mdi-clipboard-check-outline',
        //   role: [
        //     'DT_notaras',
        //     'DT_notaro_padejejas',
        //     'DT_notaro_atstovas',
        //     'DT_teismas',
        //     'DT_antstolis',
        //     'RG_STSR_registrat',
        //     'RG_NTR_registrat', 'RG_NTR_vadovas'
        //   ],
        // },
        {
          key: 'vykdomasis',
          type: 'sutartinis priverstinis vykdomasis',
          title: 'Notaro vykdomasis įrašas',
          icon: 'mdi-clipboard-list-outline',
          role: [
            'DT_notaras',
            'DT_notaro_padejejas',
            'DT_notaro_atstovas',
            'DT_teismas',
            'RG_STSR_registrat',
            'RG_NTR_registrat',
            'RG_NTR_vadovas',
          ],
        },
        {
          key: 'archyvas',
          type: 'sutartinis priverstinis continued',
          title: 'Atstatymas iš archyvo',
          icon: 'mdi-clipboard-text-play-outline',
          role: [
            'DT_notaras',
            'DT_notaro_padejejas',
            'DT_notaro_atstovas',
            'DT_teismas',
            'DT_antstolis',
            'DT_kita_institucija',
            'DT_JA',
            'RG_STSR_registrat',
            'RG_NTR_registrat',
            'RG_NTR_vadovas',
          ],
        },
      ],
      vykdomasisList: [
        {
          key: 'atlikimas',
          type: 'continued',
          title: 'Atlikimas',
          icon: 'mdi-credit-card-check-outline',
          role: [
            'DT_notaras',
            'DT_notaro_padejejas',
            'DT_notaro_atstovas',
            'RG_STSR_registrat',
            'RG_NTR_registrat',
            'RG_NTR_vadovas',
          ],
        },
        {
          key: 'pakeitimas',
          type: 'continued',
          title: 'Pakeitimas',
          icon: 'mdi-credit-card-refresh-outline',
          role: [
            'DT_notaras',
            'DT_notaro_padejejas',
            'DT_notaro_atstovas',
            'RG_STSR_registrat',
            'RG_NTR_registrat',
            'RG_NTR_vadovas',
          ],
        },
        {
          key: 'panaikinimas',
          type: 'continued',
          title: 'Panaikinimas',
          icon: 'mdi-credit-card-remove-outline',
          role: [
            'DT_notaras',
            'DT_notaro_padejejas',
            'DT_notaro_atstovas',
            'DT_teismas',
            'RG_STSR_registrat',
            'RG_NTR_registrat',
            'RG_NTR_vadovas',
          ],
        },
      ],
    }
  },
  computed: {
    ...mapGetters(['objektasID']),

    filterTipasList() {
      return this.tipasList.filter(tipas => {
        return this.roleOr(tipas.role)
      })
    },
    filterVeiksmasList() {
      return this.veiksmasList.filter(veiksmas => {
        return (
          this.roleOr(veiksmas.role) && veiksmas.type.includes(this.tipas.type)
        )
      })
    },
    filterVykdomasisList() {
      return this.vykdomasisList.filter(vykdomasis => {
        return this.roleOr(vykdomasis.role)
      })
    },
    isVykdomasis() {
      return this.combineType.includes('vykdomasis')
    },
    isVeiksmas() {
      return this.veiksmas !== null
    },
    isTipas() {
      return this.tipas !== null
    },
    isVeiksmasNew() {
      return this.combineType.includes('new')
    },
    isVeiksmasContinued() {
      return this.combineType.includes('continued')
    },
    isPerleidimas() {
      return this.tipas.type === 'perleidimas'
    },
    combineType() {
      let type = ''
      this.tipas && (type += this.tipas.type)
      this.veiksmas && (type += ' ' + this.veiksmas.type)
      this.vykdomasis && (type += ' ' + this.vykdomasis.type)
      return type
    },
    isKodas() {
      return this.objektas && this.objektas.obj_identifikavimo_kodas !== null
    },
    hipotekaTipasMap() {
      return HipotekaMap['hipotekaTipas'][this.hipotekaTipas] ?? []
    },
    hipotekaButtonText() {
      return this.hipotekaTipasMap.button
    },
    hipotekaTitle() {
      return this.hipotekaTipasMap.title
    },
    hipotekaRole() {
      return this.roleOr(this.hipotekaTipasMap.role)
    },
    hipotekaTipas() {
      return (
        (this.tipas ? this.tipas.key : '') +
        '-' +
        (this.veiksmas ? this.veiksmas.key : '') +
        (this.vykdomasis ? '-' + this.vykdomasis.key : '')
      )
    },
    searchTipas() {
      return this.tipasList.filter(tipas => {
        return this.objektas && this.objektas.obj_tipas.includes(tipas.key)
      })[0]
    },
    dokumentasNerastasMsg() {
      return 'Dokumentas nerastas'
    },
    canSubmit() {
      return this.searchKodas || this.isVeiksmasNew
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.pageloading = false
    },
    checkVykdomasis(toggle, active, vykdomasis) {
      this.vykdomasis = vykdomasis
      this.objektas = null
      this.objektasNerastas = false
      if (!active) {
        toggle()
      }
    },
    checkVeiksmas(toggle, active, veiksmas) {
      this.veiksmas = veiksmas
      this.vykdomasis = null
      this.objektas = null
      this.objektasNerastas = false
      if (!active) {
        toggle()
      }
    },
    checkTipas(toggle, active, tipas) {
      this.tipas = tipas
      this.tipasKitas = null
      this.objektasNerastas = false
      this.vykdomasis = null
      this.veiksmas = null
      this.objektas = null
      if (!active) {
        toggle()
      }
      if (this.isPerleidimas) {
        this.gotoPerleidimas()
      }
    },
    checkKodas() {
      this.loadingSearch = true
      this.objektas = null
      this.objektasNerastas = false
      this.tipasKitas = null

      const data = {
        obj_tipas: this.hipotekaTipas,
        obj_identifikavimo_kodas: this.searchKodas,
      }
      this.$axios
        .post(`objektas/search`, data)
        .then(res => {
          this.objektas = res.data.objektas

          if (!this.objektas.obj_tipas.includes(this.tipas.key)) {
            if (this.searchTipas) {
              this.tipas = this.searchTipas
              this.tipasKitas = 'tipasKitas'
            } else {
              this.objektasNerastas = true
              this.objektasNerastasMsg = this.dokumentasNerastasMsg
            }
            this.loadingSearch = false
          } else {
            this.sukurtiHipoteka()
          }
        })
        .catch(err => {
          this.objektasNerastas = true
          this.objektasNerastasMsg =
            err.response.data.message ?? this.dokumentasNerastasMsg
          this.loadingSearch = false
          // window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {})
    },
    sukurtiHipoteka() {
      this.loadingSearch = true
      const data = {
        obj_tipas: this.hipotekaTipas,
        dok_id: this.objektas ? this.objektas.dok_id : null,
        vyk_id: this.objektas ? this.objektas.vyk_id : null,
      }
      this.$axios
        .post(`objektas`, data)
        .then(res => {
          this.$store.dispatch('objektasID', res.data.objektas.obj_id)
          this.$store.dispatch('hipotekaTipas', this.hipotekaTipas)
          this.$store.dispatch('objektasVeiksmas', 0)
          this.$router.push({
            name: 'hipotekaPranesimas',
            params: {
              objektasID: this.objektasID,
            },
          })
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
          this.loadingSearch = false
        })
        .finally(() => {})
    },
    gotoPerleidimas() {
      this.$router.push({
        name: 'hipotekaPerleidimas',
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.tipasKitas {
  color: #686868;
}
.dataContainer {
  max-width: 800px;
}
</style>
